import { inject, Injectable } from "@angular/core";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import { NiceAsyncTypeaheadProvider, NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { lastValueFrom, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { translateTranslationObject } from "../../../pipes/translate-translation-object.pipe";
import { FindOptionsDto } from "../../common/dto/find-options.dto";
import { Pricings } from "../models/pricings.model";
import { PricingsApi } from "./pricings.api";



@Injectable()
export class PricingsTypeaheadApi extends NiceAsyncTypeaheadProvider<Pricings> {
    private readonly api = inject(PricingsApi);

    public readonly resource = "pricings";

    private readonly pageSize = 20;

    public override async getById(id: number): Promise<Pricings> {
        return lastValueFrom(this.api.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number,
        options?: FindOptionsDto
    ): Observable<NiceAsyncTypeaheadSearchResult<Pricings>> {
        const dto: FindOptionsDto = {
            searchQuery,
            page,
            pageSize: this.pageSize
        };

        if (isPropertyDefined(options, "ignoreIds")) {
            dto.ignoreIds = options.ignoreIds.map((x) => x);
        }

        return this.api.search(dto).pipe(
            map((items) => ({
                items,
                nextPage: items.length === this.pageSize ? page + 1 : null
            }))
        );
    }

    public override format(item: Pricings): string {
        return translateTranslationObject(item.name)
    }
}
